export enum ORDER_TYPE {
  DONATION = 'donation',
  COURSE = 'course',
  BASIC_MENTORING = 'basic-mentoring',
  ADVANCED_MENTORING = 'advanced-mentoring',
  NONE = 'none'
}
export enum DONATION_PURPOSE {
  VOLUNTEER_MENTORS = 'Mentorzy wolontariusze',
  KNOWLEDGE_DB = 'Baza wiedzy',
  STYPENDIUM = 'Stypendium',
  ANY = 'Dowolny'
}
